export const promotionsTypes = {
  DESCONTO_PERCENTUAL: 'DESCONTO_PERCENTUAL',
  DESCONTO_VALOR_FIXO: 'DESCONTO_VALOR_FIXO',
  LEVE_X_PAGUE_Y: 'LEVE_X_PAGUE_Y',
  COMPRE_E_GANHE: 'COMPRE_E_GANHE',
  COMBO_PRECO_FIXO: 'COMBO_PRECO_FIXO',
  FRETE_GRATIS: 'FRETE_GRATIS',
  BORDAS: 'BORDAS',
  DESCONTO_TAMANHO: 'DESCONTO_TAMANHO',
};

export const promotionsDateTypes = {
  DATA_INDETERMINADA: 'DATA_INDETERMINADA',
  DATA_FIXA: 'DATA_FIXA',
  DATA_PERIODO: 'DATA_PERIODO'
};

export const promotionsBenefitTypes = {
  PERCENTUAL: 'PERCENTUAL',
  VALOR_FIXO: 'VALOR_FIXO',
  GRATIS: 'GRATIS',
};